import { render, staticRenderFns } from "./barEacher1.vue?vue&type=template&id=93654d58&"
import script from "./barEacher1.vue?vue&type=script&lang=js&"
export * from "./barEacher1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports